"use client";

import { FiltersIcon } from "../lifestyleIcons";

interface AllFiltersButtonProps {
  activeCount: number;
  onClick: () => void;
}

/**
 * "All filters". Mobile draws it as a 40px icon tile with the count as a pip
 * hanging off the corner; from `lg:` up the label and an inline count return.
 */
export default function AllFiltersButton({ activeCount, onClick }: AllFiltersButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={activeCount > 0 ? `All filters, ${activeCount} applied` : "All filters"}
      className={`relative flex items-center justify-center lg:justify-start shrink-0 w-10 lg:w-[160px] min-h-10 lg:min-h-11 px-0 lg:px-2.5 gap-2 font-roboto text-sm font-medium leading-5 bg-white rounded border transition-colors ${
        activeCount > 0 ? "text-primary border-primary" : "text-gray-1 border-transparent hover:border-gray-8"
      }`}>
      <FiltersIcon className="shrink-0 w-6 h-6" />
      <span className="hidden lg:inline">All filters</span>
      {activeCount > 0 && (
        <span className="flex items-center justify-center absolute lg:static -top-1 right-0 lg:right-auto min-w-3.5 lg:min-w-5 h-3.5 lg:h-5 px-1 font-jost text-[11px] font-semibold leading-3.5 text-white bg-primary rounded-full">
          {activeCount}
        </span>
      )}
    </button>
  );
}
